class SubscriptionDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#SubscriptionDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.triggerButton = document.querySelector('#subscription-button');
        this.setHeaderSubscriptionAccessibility();
        this.setElementsSubscriptionAccessibility();

        this.querySelectorAll('.subscription-input[name="subscription-product"]').forEach((elm) => {
            elm.addEventListener('click', this.selectPack.bind(this));
        });

        this.subscriptionStartInputs = this.querySelectorAll('.subscription-input[name="subscription-start"]');
        this.subscriptionStartInputs.forEach((elm) => {
            elm.addEventListener('click', this.selectNumero.bind(this));
        });

        this.submitButton = this.querySelector('button[type="submit"]');
        this.inputProductId = this.querySelector('#subscription-product-id');
        this.inputSellingPlanId = this.querySelector('#subscription-selling-plan-id');
        this.subscriptionStart = null;
        this.subscriptionSelectedName = null;
        this.startBox = this.querySelector('#subscription-start-box');

        this.submitButton.addEventListener('click', this.handleSubmitButtonClick.bind(this));
    }

    handleSubmitButtonClick(evt) {
        if (!evt.currentTarget.getAttribute('disabled')) window.currentDrawer = this;
    }

    selectNumero(evt) {
        const input = evt.currentTarget;
        const startCurrentNumero = input.getAttribute('id').includes('current');
        const newStart = startCurrentNumero ? 'current' : 'next';
        if (newStart === this.subscriptionStart) {
            this.subscriptionStart = null;
            input.checked = false;
            this.classList.remove('option-selected-second');
        } else {
            this.subscriptionStart = newStart;
            this.classList.add('option-selected-second');
        }
        this.updateSubscriptionInput();
    }

    selectPack(evt) {
        const input = evt.currentTarget;
        const isPlatineSubscription = input.getAttribute('id').includes('platine');
        const subscriptionName = isPlatineSubscription ? 'platineProduct' : 'diamantProduct';

        if (this.subscriptionSelectedName === subscriptionName) {
            this.subscriptionSelected = null;
            this.subscriptionSelectedName = null;
            input.checked = false;
            this.startBox.classList.add('xhidden');
            this.classList.remove('option-selected');
            this.classList.remove('option-selected-second');
        } else {
            this.subscriptionSelected = window.mosaiqueSettings[subscriptionName];
            this.subscriptionSelectedName = subscriptionName;
            this.startBox.classList.remove('xhidden');
            this.classList.add('option-selected');
        }

        this.updateSubscriptionInput();
        this.toggleSubscriptionStartLabels();
    }

    updateSubscriptionInput() {
        if (this.subscriptionStart !== null && this.subscriptionSelected) {
            if (this.subscriptionStart === 'current' && this.subscriptionSelected.currentAvailable) {
                this.inputProductId.value = this.subscriptionSelected.currentId;
                this.inputSellingPlanId.value = this.subscriptionSelected.currentSellingPlanId;
                this.submitButton.removeAttribute('disabled');
            } else if (this.subscriptionStart !== 'current' && this.subscriptionSelected.nextAvailable) {
                this.inputProductId.value = this.subscriptionSelected.nextId;
                this.inputSellingPlanId.value = this.subscriptionSelected.nextSellingPlanId;
                this.submitButton.removeAttribute('disabled');
            } else {
                this.inputProductId.value = '';
                this.inputSellingPlanId.value = '';
                this.submitButton.setAttribute('disabled', 'true');
                this.subscriptionStartInputs.forEach((elm) => (elm.checked = false));
            }
        } else {
            this.submitButton.setAttribute('disabled', 'true');
            this.inputProductId.value = '';
            this.inputSellingPlanId.value = '';
            this.subscriptionStartInputs.forEach((elm) => (elm.checked = false));
        }
    }

    toggleSubscriptionStartLabels() {
        this.querySelectorAll('.input-start-label').forEach((elm) => {
            const current = elm.getAttribute('for') === 'subscription-start-current';

            if (
                this.subscriptionSelected &&
                ((current && this.subscriptionSelected.currentAvailable) ||
                    (!current && this.subscriptionSelected.nextAvailable))
            ) {
                elm.querySelector('span').classList.remove('xtext-text-20');
                elm.setAttribute('aria-disabled', 'false');
            } else {
                elm.querySelector('span').classList.add('xtext-text-20');
                elm.setAttribute('aria-disabled', 'true');
            }
        });

        this.subscriptionStartInputs.forEach((elm) => {
            const current = elm.getAttribute('id') === 'subscription-start-current';
            if (
                this.subscriptionSelected &&
                ((current && this.subscriptionSelected.currentAvailable) ||
                    (!current && this.subscriptionSelected.nextAvailable))
            ) {
                elm.removeAttribute('disabled');
            } else {
                elm.setAttribute('disabled', 'true');
            }
        });
    }

    setHeaderSubscriptionAccessibility() {
        if (!this.triggerButton) return;

        this.triggerButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(this.triggerButton);
        });
        this.triggerButton.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(this.triggerButton);
            }
        });
    }

    setElementsSubscriptionAccessibility() {
        const buttons = document.querySelectorAll('.subscription-button');

        for (const button of buttons) {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                this.open(button);
            });
            button.addEventListener('keydown', (event) => {
                if (event.code.toUpperCase() === 'SPACE') {
                    event.preventDefault();
                    this.open(button);
                }
            });
        }
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });

        // document.body.classList.add('no-scroll');
        toggleBodyScroll(false);

        this.addEventListener(
            'transitionend',
            () => {
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(document.getElementById('SubscriptionDrawer'), focusElement);
            },
            { once: true }
        );
    }

    close(toggleScroll = true) {
        this.classList.remove('active');
        // document.body.classList.remove('no-scroll');
        if (toggleScroll) toggleBodyScroll(true);
        removeTrapFocus(this.activeElement);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('subscription-drawer', SubscriptionDrawer);
